<template>
  <div>
    <el-form-item label="提示文字">
      <el-input size="small" v-model="value.placeholder" placeholder="请设置提示语" />
    </el-form-item>
  </div>
</template>

<script>
import { getSystemModelList } from '@/api/ops/systemModel'
export default {
  name: "SystemTypeInputConfig",
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {

    };
  },
  created() {
    this.handleChange();
  },
  methods: {
    handleChange() {
      getSystemModelList().then(res => {
        this.value.options = res.data;
      });
    }
  }
};
</script>

